<template>
  <div>
    <div class="field has-addons">
      <div class="control" :class="{'is-expanded': isFullWidth}">
        <input class="input" readonly="readonly" type="text" :value="value" />
      </div>
      <div class="control">
        <button class="button" @click="viewCV" :class="[ link ? 'is-active-tool-button': '']">
          <img :src="paperclipImage" />
        </button>
      </div>
    </div>
    <p class="f-12" v-if="link"><a @click="viewCV">View</a> or <a :href="link" target="_blank">Download</a></p>
</div>
</template>

<script>
import PaperclipHighlighted from '@/assets/paperclip-highlighted.svg'
import PaperclipNormal from '@/assets/paperclip.svg'

export default {
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    isFullWidth: {
      type: Boolean,
      required: false
    },
    link: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    paperclipImage () {
      if (this.link && this.link.length > 0) {
        return PaperclipHighlighted
      } else {
        return PaperclipNormal
      }
    }
  },
  methods: {
    viewCV () {
      this.$store.dispatch('cvViewer/setCVUrl', this.link)
    }
  }
}
</script>

<style lang="scss" scoped>

.field {
  margin-bottom: 8px;
}
.input-file {
  overflow: hidden;
  position: absolute;
  visibility: hidden;
}

.control .button {
  width: 2.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/jobseekers/resume-field-readonly.vue